<template>
  <v-card
    class="privacy-box"
    outlined
    tile
    v-html="$t('common.privacy')"
  >

  </v-card>


</template>

<script>
export default {
  name: "Privacy"
}
</script>

<style  lang="scss">
.privacy-box{
  h1,h2,h3{
    color: black;
  }
  font-size: 15px!important;
  padding-bottom: 100px!important;
  color:#0A0A0A ;
  p{
    //margin-left: 10px!important;
  }
  ul {

    margin-left: 40px!important;
  }
}





</style>
